(function () {
    'use strict';

    angular
        .module('cog.shared')
        .factory('notificationService', NotificationService);

    /* @ngInject */
    function NotificationService($mdToast, $mdDialog, $rootScope, appSettings) {
        var service: INotificationService = {
            displayInfo: displayInfo,
            displayError: displayError,
            showMessage: showMessage,
            displayMessage: displayMessage,
            subscribe_goBMBetTypeSchedule: subscribe_goBMBetTypeSchedule,
            notify_goBMBetTypeSchedule: notify_goBMBetTypeSchedule,
            subscribe_onBMWagerTicket: subscribe_onBMWagerTicket,
            notify_onBMWagerTicket: notify_onBMWagerTicket,
            subscribe_goBetTypeSchedule: subscribe_goBetTypeSchedule,
            notify_goBetTypeSchedule: notify_goBetTypeSchedule,
            //subscribe_newMailNotification: subscribe_newMailNotification,
            //notify_newMailNotification: notify_newMailNotification,
            subscribe_onWagerTicket: subscribe_onWagerTicket,
            notify_onWagerTicket: notify_onWagerTicket,
            subscribe_onBetTypeSelection: subscribe_onBetTypeSelection,
            notify_onBetTypeSelection: notify_onBetTypeSelection,
            //subscribe_GetTeaserSchedule: subscribe_GetTeaserSchedule,
            //notify_GetTeaserSchedule: notify_GetTeaserSchedule,
            //subscribe_MSG_SELECTED_TEASER: subscribe_MSG_SELECTED_TEASER,
            //notify_MSG_SELECTED_TEASER: notify_MSG_SELECTED_TEASER,
            //subscribe_MSG_BM_BET_TYPE_EVENT: subscribe_MSG_BM_BET_TYPE_EVENT,
            //notify_MSG_BM_BET_TYPE_EVENT: notify_MSG_BM_BET_TYPE_EVENT,
            subscribe_MSG_BM_BET_EVENT: subscribe_MSG_BM_BET_EVENT,
            notify_MSG_BM_BET_EVENT: notify_MSG_BM_BET_EVENT,
            subscribe_MSG_BM_FILLOPEN_EVENT: subscribe_MSG_BM_FILLOPEN_EVENT,
            notify_MSG_BM_FILLOPEN_EVENT: notify_MSG_BM_FILLOPEN_EVENT,
            subscribe_onBetConfirmView: subscribe_onBetConfirmView,
            notify_onBetConfirmView: notify_onBetConfirmView,
            subscribe_transactionsRptToTop: subscribe_transactionsRptToTop,
            notify_transactionsRptToTop: notify_transactionsRptToTop,
            subscribe_toggleSport: subscribe_toggleSport,
            notify_toggleSport: notify_toggleSport,
            subscribe_onMenuTeaserLink: subscribe_onMenuTeaserLink,
            notify_onMenuTeaserLink: notify_onMenuTeaserLink,
            subscribe_logout: subscribe_logout,
            notify_logout: notify_logout,
            subscribe_MSG_SAVE_SELECTION: subscribe_MSG_SAVE_SELECTION,
            notify_MSG_SAVE_SELECTION: notify_MSG_SAVE_SELECTION,
            subscribe_MSG_BM_BET_CANCEL_EVENT: subscribe_MSG_BM_BET_CANCEL_EVENT,
            notify_MSG_BM_BET_CANCEL_EVENT: notify_MSG_BM_BET_CANCEL_EVENT,
            subscribe_MSG_FILLOPEN_BET_SET_FAIL_EVENT: subscribe_MSG_FILLOPEN_BET_SET_FAIL_EVENT,
            notify_MSG_FILLOPEN_BET_SET_FAIL_EVENT: notify_MSG_FILLOPEN_BET_SET_FAIL_EVENT,
            subscribe_MSG_FILLOPEN_CANCEL_LEG_EVENT: subscribe_MSG_FILLOPEN_CANCEL_LEG_EVENT,
            notify_MSG_FILLOPEN_CANCEL_LEG_EVENT: notify_MSG_FILLOPEN_CANCEL_LEG_EVENT,
            subscribe_onCustomerAvailableOptions: subscribe_onCustomerAvailableOptions,
            notify_onCustomerAvailableOptions: notify_onCustomerAvailableOptions,
            subscribe_MSG_BET_SELECT: subscribe_MSG_BET_SELECT,
            notify_MSG_BET_SELECT: notify_MSG_BET_SELECT,
            subscribe_MSG_CONTINUE_BET: subscribe_MSG_CONTINUE_BET,
            notify_MSG_CONTINUE_BET: notify_MSG_CONTINUE_BET,
            subscribe_onTransactionsLoad: subscribe_onTransactionsLoad,
            notify_onTransactionsLoad: notify_onTransactionsLoad,
            subscribe_onPagination: subscribe_onPagination,
            notify_onPagination: notify_onPagination,
            //subscribe_ACC_ROLE_enableSaveState: subscribe_ACC_ROLE_enableSaveState,
            //notify_ACC_ROLE_enableSaveState: notify_ACC_ROLE_enableSaveState,
            //subscribe_ACC_ROLE_saveRolePermissions: subscribe_ACC_ROLE_saveRolePermissions,
            //notify_ACC_ROLE_saveRolePermissions: notify_ACC_ROLE_saveRolePermissions,
            //subscribe_MSG_ACCOUNT_SETTINGS_LOADED: subscribe_MSG_ACCOUNT_SETTINGS_LOADED,
            //notify_MSG_ACCOUNT_SETTINGS_LOADED: notify_MSG_ACCOUNT_SETTINGS_LOADED,
            //subscribe_BM_SETTINGS_ARRANGE_enableSaveState: subscribe_BM_SETTINGS_ARRANGE_enableSaveState,
            //notify_BM_SETTINGS_ARRANGE_enableSaveState: notify_BM_SETTINGS_ARRANGE_enableSaveState,
            //subscribe_BM_SETTINGS_ARRANGE_saveFoldersOrder: subscribe_BM_SETTINGS_ARRANGE_saveFoldersOrder,
            //notify_BM_SETTINGS_ARRANGE_saveFoldersOrder: notify_BM_SETTINGS_ARRANGE_saveFoldersOrder,
            subscribe_MSG_BM_RELOAD_PENDING: subscribe_MSG_BM_RELOAD_PENDING,
            notify_MSG_BM_RELOAD_PENDING: notify_MSG_BM_RELOAD_PENDING,
            //subscribe_CogPermissions: subscribe_CogPermissions,
            //notify_CogPermissions: notify_CogPermissions,
            //subscribe_todayEvents: subscribe_todayEvents,
            //notify_todayEvents: notify_todayEvents,
            //subscribe_shiftChange: subscribe_shiftChange,
            //notify_shiftChange: notify_shiftChange,
            subscribe_showContinue: subscribe_showContinue,
            notify_showContinue: notify_showContinue,
            subscribe_toggleCategory: subscribe_toggleCategory,
            notify_toggleCategory: notify_toggleCategory,
            subscribe_clearMenu: subscribe_clearMenu,
            notify_clearMenu: notify_clearMenu,
            //subscribe_LEAGUE_SETTINGS_SPORT_ARRANGE_enableSaveState: subscribe_LEAGUE_SETTINGS_SPORT_ARRANGE_enableSaveState,
            //notify_LEAGUE_SETTINGS_SPORT_ARRANGE_enableSaveState: notify_LEAGUE_SETTINGS_SPORT_ARRANGE_enableSaveState,
            //subscribe_LEAGUE_SETTINGS_SPORT_ARRANGE_saveFoldersOrder: subscribe_LEAGUE_SETTINGS_SPORT_ARRANGE_saveFoldersOrder,
            //notify_LEAGUE_SETTINGS_SPORT_ARRANGE_saveFoldersOrder: notify_LEAGUE_SETTINGS_SPORT_ARRANGE_saveFoldersOrder,
            //subscribe_LEAGUE_SETTINGS_DESKTOP_ARRANGE_enableSaveState: subscribe_LEAGUE_SETTINGS_DESKTOP_ARRANGE_enableSaveState,
            //notify_LEAGUE_SETTINGS_DESKTOP_ARRANGE_enableSaveState: notify_LEAGUE_SETTINGS_DESKTOP_ARRANGE_enableSaveState,
            //subscribe_LEAGUE_SETTINGS_DESKTOP_ARRANGE_saveFoldersOrder: subscribe_LEAGUE_SETTINGS_DESKTOP_ARRANGE_saveFoldersOrder,
            //notify_LEAGUE_SETTINGS_DESKTOP_ARRANGE_saveFoldersOrder: notify_LEAGUE_SETTINGS_DESKTOP_ARRANGE_saveFoldersOrder,
            //subscribe_btcSentTrans: subscribe_btcSentTrans,
            //notify_btcSentTrans: notify_btcSentTrans,
            subscribe_betTypes_Loaded: subscribe_betTypes_Loaded,
            notify_betTypes_Loaded: notify_betTypes_Loaded,
            //subscribe_CogAccountHeader_Change: subscribe_CogAccountHeader_Change,
            //notify_CogAccountHeader_Change: notify_CogAccountHeader_Change,
            //subscribe_COG_Account_Loader: subscribe_COG_Account_Loader,
            //notify_COG_Account_Loader: notify_COG_Account_Loader,
            subscribe_allowSports: subscribe_allowSports,
            notify_allowSports: notify_allowSports,
            //subscribe_CogAccountHeader_DisplayInfo: subscribe_CogAccountHeader_DisplayInfo,
            //notify_CogAccountHeader_DisplayInfo: notify_CogAccountHeader_DisplayInfo,
            notify_home_Button: notify_home_Button,
            subscribe_home_Button: subscribe_home_Button,
            notify_clearMultipleBets: notify_clearMultipleBets,
            subscribe_clearMultipleBets: subscribe_clearMultipleBets,
            notify_clearBetTypeonPanel: notify_clearBetTypeonPanel,
            subscribe_clearBetTypeonPanel: subscribe_clearBetTypeonPanel,
            notify_onDeleteWager : notify_onDeleteWager,
            subscribe_onDeleteWager : subscribe_onDeleteWager
        };
        return service;

        //////////// 

        function displayError(error: string) {
            //The toastController gets an instance of toastService, so the error message is exposed
            //via the message property and the controller provides it to the toast.html view
            this.message = error;
            $mdToast.show(
                $mdToast.simple()
                    .content(this.message)
                    .position('bottom right')
                    .hideDelay(3000)
            );
            /*$mdToast.show({
                controller: 'ToastController',
                controllerAs: 'vm',
                templateUrl: appSettings.sharedPath + 'notifications/Toast.tmpl.html',
                hideDelay: 3000,
                position: 'bottom right',
                locals: { msg: this.message, css: 'error' }
            });*/
        }
        function displayInfo(message) {
            this.message = message;
            $mdToast.show({
                controller: 'ToastController',
                controllerAs: 'vm',
                templateUrl: appSettings.sharedPath + 'notifications/Toast.tmpl.html',
                hideDelay: 1000,
                position: 'bottom right',
                locals: { msg: this.message, css: '' }
            });
        }
        function showMessage(message) {
            var alert = $mdDialog.alert()
                .title('Attention')
                .htmlContent(message)
                .ok('Close');
            $mdDialog
                .show(alert)
                .finally(function () {
                    alert = undefined;
                });
        }
        function displayMessage(msg, duration, position) {
            this.message = msg;
            $mdToast.show(
                $mdToast.simple()
                    .content(this.message)
                    .position(position)
                    .hideDelay(duration)
            );
        }

        function subscribe_CogPermissions(scope, callback) {
            var handler = $rootScope.$on('PERMISSIONS_LOAD_EVENT', callback);
            scope.$on('$destroy', handler);
        }
        function notify_CogPermissions() {
            $rootScope.$emit('PERMISSIONS_LOAD_EVENT');
        }

        /******************* CPANEL BM-SETTINGS BLOCK ********************/

        function subscribe_BM_SETTINGS_ARRANGE_enableSaveState(scope, callback) {
            var handler = $rootScope.$on('BM_SETTINGS_ARRANGE_enableSaveState', callback);
            scope.$on('$destroy', handler);
        }

        function notify_BM_SETTINGS_ARRANGE_enableSaveState(enable: boolean) {
            $rootScope.$emit('BM_SETTINGS_ARRANGE_enableSaveState', enable);
        }

        function subscribe_BM_SETTINGS_ARRANGE_saveFoldersOrder(scope, callback) {
            var handler = $rootScope.$on('BM_SETTINGS_ARRANGE_saveFoldersOrder', callback);
            scope.$on('$destroy', handler);
        }

        function notify_BM_SETTINGS_ARRANGE_saveFoldersOrder() {
            $rootScope.$emit('BM_SETTINGS_ARRANGE_saveFoldersOrder');
        }
        // SPORT
        function subscribe_LEAGUE_SETTINGS_SPORT_ARRANGE_enableSaveState(scope, callback) {
            var handler = $rootScope.$on('LEAGUE_SETTINGS_SPORT_ARRANGE_enableSaveState', callback);
            scope.$on('$destroy', handler);
        }

        function notify_LEAGUE_SETTINGS_SPORT_ARRANGE_enableSaveState(enable: boolean) {
            $rootScope.$emit('LEAGUE_SETTINGS_SPORT_ARRANGE_enableSaveState', enable);
        }

        function subscribe_LEAGUE_SETTINGS_SPORT_ARRANGE_saveFoldersOrder(scope, callback) {
            var handler = $rootScope.$on('LEAGUE_SETTINGS_SPORT_ARRANGE_saveFoldersOrder', callback);
            scope.$on('$destroy', handler);
        }

        function notify_LEAGUE_SETTINGS_SPORT_ARRANGE_saveFoldersOrder() {
            $rootScope.$emit('LEAGUE_SETTINGS_SPORT_ARRANGE_saveFoldersOrder');
        }
        // DESKTOP
        function subscribe_LEAGUE_SETTINGS_DESKTOP_ARRANGE_enableSaveState(scope, callback) {
            var handler = $rootScope.$on('LEAGUE_SETTINGS_SPORT_ARRANGE_enableSaveState', callback);
            scope.$on('$destroy', handler);
        }

        function notify_LEAGUE_SETTINGS_DESKTOP_ARRANGE_enableSaveState(enable: boolean) {
            $rootScope.$emit('LEAGUE_SETTINGS_SPORT_ARRANGE_enableSaveState', enable);
        }

        function subscribe_LEAGUE_SETTINGS_DESKTOP_ARRANGE_saveFoldersOrder(scope, callback) {
            var handler = $rootScope.$on('LEAGUE_SETTINGS_SPORT_ARRANGE_saveFoldersOrder', callback);
            scope.$on('$destroy', handler);
        }

        function notify_LEAGUE_SETTINGS_DESKTOP_ARRANGE_saveFoldersOrder() {
            $rootScope.$emit('LEAGUE_SETTINGS_SPORT_ARRANGE_saveFoldersOrder');
        }

        /******************* CPANEL BM BLOCK ********************/
        function subscribe_goBMBetTypeSchedule(scope, callback) {
            var handler = $rootScope.$on('goBMBetTypeSchedule', callback);
            scope.$on('$destroy', handler);
        }
        function notify_goBMBetTypeSchedule(tp: string) {
            $rootScope.$emit('goBMBetTypeSchedule', tp);
        }
        function subscribe_onBMWagerTicket(scope, callback) {
            var handler = $rootScope.$on('onBMWagerTicket', callback);
            scope.$on('$destroy', handler);
        }
        function notify_onBMWagerTicket() {
            $rootScope.$emit('onBMWagerTicket');
        }
        function subscribe_GetTeaserSchedule(scope, callback) {
            var handler = $rootScope.$on('GetTeaserSchedule', callback);
            scope.$on('$destroy', handler);
        }
        function notify_GetTeaserSchedule(arg: any) {
            $rootScope.$emit('GetTeaserSchedule', arg);
        }
        function subscribe_MSG_SELECTED_TEASER(scope, callback) {
            var handler = $rootScope.$on('MSG_SELECTED_TEASER', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_SELECTED_TEASER(arg: any) {
            $rootScope.$emit('MSG_SELECTED_TEASER', arg);
        }
        function subscribe_MSG_BM_BET_TYPE_EVENT(scope, callback) {
            var handler = $rootScope.$on('MSG_BM_BET_TYPE_EVENT', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_BM_BET_TYPE_EVENT() {
            $rootScope.$emit('MSG_BM_BET_TYPE_EVENT');
        }
        function subscribe_MSG_BM_BET_EVENT(scope, callback) {
            var handler = $rootScope.$on('MSG_BM_BET_EVENT', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_BM_BET_EVENT() {
            $rootScope.$emit('MSG_BM_BET_EVENT');
        }
        function subscribe_MSG_BM_FILLOPEN_EVENT(scope, callback) {
            var handler = $rootScope.$on('MSG_BM_FILLOPEN_EVENT', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_BM_FILLOPEN_EVENT() {
            $rootScope.$emit('MSG_BM_FILLOPEN_EVENT');
        }
        function subscribe_onBetConfirmView(scope, callback) {
            var handler = $rootScope.$on('onBetConfirmView', callback);
            scope.$on('$destroy', handler);
        }
        function notify_onBetConfirmView() {
            $rootScope.$emit('onBetConfirmView');
        }
        function subscribe_transactionsRptToTop(scope, callback) {
            var handler = $rootScope.$on('transactionsRptToTop', callback);
            scope.$on('$destroy', handler);
        }
        function notify_transactionsRptToTop() {
            $rootScope.$emit('transactionsRptToTop');
        }
        function subscribe_MSG_BM_BET_CANCEL_EVENT(scope, callback) {
            var handler = $rootScope.$on('MSG_BM_BET_CANCEL_EVENT', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_BM_BET_CANCEL_EVENT(id: string) {
            $rootScope.$emit('MSG_BM_BET_CANCEL_EVENT', id);
        }
        function subscribe_MSG_FILLOPEN_BET_SET_FAIL_EVENT(scope, callback) {
            var handler = $rootScope.$on('MSG_FILLOPEN_BET_SET_FAIL_EVENT', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_FILLOPEN_BET_SET_FAIL_EVENT(data: any) {
            $rootScope.$emit('MSG_FILLOPEN_BET_SET_FAIL_EVENT', data);
        }
        function subscribe_MSG_FILLOPEN_CANCEL_LEG_EVENT(scope, callback) {
            var handler = $rootScope.$on('MSG_FILLOPEN_CANCEL_LEG_EVENT', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_FILLOPEN_CANCEL_LEG_EVENT(id: string) {
            $rootScope.$emit('MSG_FILLOPEN_CANCEL_LEG_EVENT', id);
        }
        function subscribe_MSG_ACCOUNT_SETTINGS_LOADED(scope, callback) {
            var handler = $rootScope.$on('MSG_ACCOUNT_SETTINGS_LOADED', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_ACCOUNT_SETTINGS_LOADED() {
            $rootScope.$emit('MSG_ACCOUNT_SETTINGS_LOADED');
        }
        function subscribe_MSG_BM_RELOAD_PENDING(scope, callback) {
            var handler = $rootScope.$on('onBMPendingReload', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_BM_RELOAD_PENDING() {
            $rootScope.$emit('onBMPendingReload');
        }
        function subscribe_todayEvents(scope, callback) {
            var handler = $rootScope.$on('MSG_FILTER_TODAY_EVENTS', callback);
            scope.$on('$destroy', handler);
        }
        function notify_todayEvents(showToday: boolean) {
            $rootScope.$emit('MSG_FILTER_TODAY_EVENTS', showToday);
        }

        function subscribe_shiftChange(scope, callback) {
            var handler = $rootScope.$on('MSG_SHIFT_CHANGE', callback);
            scope.$on('$destroy', handler);
        }
        function notify_shiftChange(shiftInfo: any) {
            $rootScope.$emit('MSG_SHIFT_CHANGE', shiftInfo);
        }

        function subscribe_showContinue(scope, callback) {
            var handler = $rootScope.$on('MSG_SHOW_CONTINUE', callback);
            scope.$on('$destroy', handler);
        }

        function notify_showContinue(showContinue: boolean) {
            $rootScope.$emit('MSG_SHOW_CONTINUE', showContinue);
        }

        function subscribe_betTypes_Loaded(scope, callback) {
            var handler = $rootScope.$on('MSG_BETTYPES_LOADED', callback);
            scope.$on('$destroy', handler);
        }

        function notify_betTypes_Loaded() {
            $rootScope.$emit('MSG_BETTYPES_LOADED');
        }

        function subscribe_allowSports(scope, callback) {
            var handler = $rootScope.$on('MSG_ALLOW_SPORTS', callback);
            scope.$on('$destroy', handler);
        }

        function notify_allowSports() {
            $rootScope.$emit('MSG_ALLOW_SPORTS');
        }

        function subscribe_home_Button(scope, callback) {
            var handler = $rootScope.$on('MSG_CHG_HOME', callback);
            scope.$on('$destroy', handler);
        }

        function notify_home_Button(redirTo: number) {
            $rootScope.$emit('MSG_CHG_HOME', redirTo);
        }

        /******************* CPANEL ACCOUNT BLOCK ********************/

        function subscribe_ACC_ROLE_enableSaveState(scope, callback) {
            var handler = $rootScope.$on('ACC_ROLE_enableSaveState', callback);
            scope.$on('$destroy', handler);
        }
        function notify_ACC_ROLE_enableSaveState(enable: boolean) {
            $rootScope.$emit('ACC_ROLE_enableSaveState', enable);
        }

        function subscribe_ACC_ROLE_saveRolePermissions(scope, callback) {
            var handler = $rootScope.$on('ACC_ROLE_saveRolePermissions', callback);
            scope.$on('$destroy', handler);
        }
        function notify_ACC_ROLE_saveRolePermissions() {
            $rootScope.$emit('ACC_ROLE_saveRolePermissions');
        }

        function subscribe_CogAccountHeader_Change(scope, callback) {
            var handler = $rootScope.$on('CogAccountHeader_Change', callback);
            scope.$on('$destroy', handler);
        }
        function notify_CogAccountHeader_Change() {
            $rootScope.$emit('CogAccountHeader_Change');
        }

        function subscribe_COG_Account_Loader(scope, callback) {
            var handler = $rootScope.$on('COGAccountLoader', callback);
            scope.$on('$destroy', handler);
        }
        function notify_COG_Account_Loader(show: boolean) {
            $rootScope.$emit('COGAccountLoader', show);
        }

        function subscribe_CogAccountHeader_DisplayInfo(scope, callback) {
            var handler = $rootScope.$on('COGAccountHeaderDisplayInfo', callback);
            scope.$on('$destroy', handler);
        }
        function notify_CogAccountHeader_DisplayInfo() {
            $rootScope.$emit('COGAccountHeaderDisplayInfo');
        }
        

        /******************* CUSTOMER BLOCK ********************/
        function subscribe_goBetTypeSchedule(scope, callback) {
            var handler = $rootScope.$on('goBetTypeSchedule', callback);
            scope.$on('$destroy', handler);
        }
        function notify_goBetTypeSchedule(tp: string, goBetTypeSchedule: boolean) {
            $rootScope.$emit('goBetTypeSchedule', tp, goBetTypeSchedule);
        }
        function subscribe_newMailNotification(scope, callback) {
            var handler = $rootScope.$on('newMailNotification', callback);
            scope.$on('$destroy', handler);
        }
        function notify_newMailNotification() {
            $rootScope.$emit('newMailNotification');
        }
        function subscribe_onWagerTicket(scope, callback) {
            var handler = $rootScope.$on('onWagerTicket', callback);
            scope.$on('$destroy', handler);
        }
        function notify_onWagerTicket() {
            $rootScope.$emit('onWagerTicket');
        }
        function subscribe_onBetTypeSelection(scope, callback) {
            var handler = $rootScope.$on('onBetTypeSelection', callback);
            scope.$on('$destroy', handler);
        }
        function notify_onBetTypeSelection(type: string, refreshMenu: boolean) {
            $rootScope.$emit('onBetTypeSelection', type, refreshMenu);
        }
        function subscribe_toggleSport(scope, callback) {
            var handler = $rootScope.$on('toggleSport', callback);
            scope.$on('$destroy', handler);
        }
        function notify_toggleSport(item: any) {
            $rootScope.$emit('toggleSport', item);
        }
        function subscribe_onMenuTeaserLink(scope, callback) {
            var handler = $rootScope.$on('onMenuTeaserLink', callback);
            scope.$on('$destroy', handler);
        }
        function notify_onMenuTeaserLink(item: any) {
            $rootScope.$emit('onMenuTeaserLink', item);
        }
        function subscribe_logout(scope, callback) {
            var handler = $rootScope.$on('logout', callback);
            scope.$on('$destroy', handler);
        }
        function notify_logout() {
            $rootScope.$emit('logout');
        }
        function subscribe_MSG_SAVE_SELECTION(scope, callback) {
            var handler = $rootScope.$on('MSG_SAVE_SELECTION', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_SAVE_SELECTION(msg: string) {
            $rootScope.$emit('MSG_SAVE_SELECTION', msg);
        }
        function subscribe_onCustomerAvailableOptions(scope, callback) {
            var handler = $rootScope.$on('onCustomerAvailableOptions', callback);
            scope.$on('$destroy', handler);
        }
        function notify_onCustomerAvailableOptions() {
            $rootScope.$emit('onCustomerAvailableOptions');
        }
        function subscribe_MSG_BET_SELECT(scope, callback) {
            var handler = $rootScope.$on('MSG_BET_SELECT', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_BET_SELECT() {
            $rootScope.$emit('MSG_BET_SELECT');
        }
        function subscribe_MSG_CONTINUE_BET(scope, callback) {
            var handler = $rootScope.$on('MSG_CONTINUE_BET', callback);
            scope.$on('$destroy', handler);
        }
        function notify_MSG_CONTINUE_BET() {
            $rootScope.$emit('MSG_CONTINUE_BET');
        }
        function subscribe_onTransactionsLoad(scope, callback) {
            var handler = $rootScope.$on('onTransactionsLoad', callback);
            scope.$on('$destroy', handler);
        }
        function notify_onTransactionsLoad(data: any) {
            $rootScope.$emit('onTransactionsLoad', data);
        }
        function subscribe_onPagination(scope, callback) {
            var handler = $rootScope.$on('onPagination', callback);
            scope.$on('$destroy', handler);
        }
        function notify_onPagination(data: any) {
            $rootScope.$emit('onPagination', data);
        }
        function subscribe_toggleCategory(scope, callback) {
            var handler = $rootScope.$on('toggleCategory', callback);
            scope.$on('$destroy', handler);
        }
        function notify_toggleCategory(show: boolean) {
            $rootScope.$emit('toggleCategory', show);
        }
        function subscribe_clearMenu(scope, callback) {
            var handler = $rootScope.$on('clearMenu', callback);
            scope.$on('$destroy', handler);
        }
        function notify_clearMenu(show: boolean) {
            $rootScope.$emit('clearMenu', show);
        }
        function subscribe_btcSentTrans(scope, callback) {
            var handler = $rootScope.$on('btcSentTrans', callback);
            scope.$on('$destroy', handler);
        }
        function notify_btcSentTrans() {
            $rootScope.$emit('btcSentTrans');
        }
        function subscribe_clearMultipleBets(scope, callback) {
            var handler = $rootScope.$on('MSG_CLEAR_MULTIPLE_BETS', callback);
            scope.$on('$destroy', handler);
        }
        function notify_clearMultipleBets() {
            $rootScope.$emit('MSG_CLEAR_MULTIPLE_BETS');
        }
        function subscribe_clearBetTypeonPanel(scope, callback) {
            var handler = $rootScope.$on('MSG_CLEAR_BETTYPE_PANEL', callback);
            scope.$on('$destroy', handler);
        }
        function notify_clearBetTypeonPanel() {
            $rootScope.$emit('MSG_CLEAR_BETTYPE_PANEL');
        }
        function notify_onDeleteWager(pWager:any) {
            $rootScope.$emit('MSG_ON_DELETE_WAGER',pWager);
        }
        function subscribe_onDeleteWager(scope, callback) {
            var handler = $rootScope.$on('MSG_ON_DELETE_WAGER',(event,data)=> callback(event,data));
            scope.$on('$destroy', handler);
        }
    }
})();